import * as React from 'react';
import { UserCog, X } from 'lucide-react';
import {Button, Badge} from 'shared-portal-components-v2';

export interface SelectedOwnerRowProps {
  name: string;
  email: string;
  isYou?: boolean;
  onRemove?: () => void;
}

export function SelectedOwnerRow(props: SelectedOwnerRowProps): React.JSX.Element {
  const { name, email, isYou = false, onRemove } = props;

  return (
    <div className="flex items-center justify-between p-3 bg-primary/5 border border-primary/20 rounded-lg">
      <div className="flex items-center space-x-3">
        <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center">
          <UserCog className="h-4 w-4 text-primary" />
        </div>

        <div>
          <div className="font-medium">
            {name}
            {isYou ? (
              <Badge className="ml-2 text-xs" variant="outline">You</Badge>
            ) : null}
          </div>
          <div className="text-sm text-muted-foreground">{email}</div>
        </div>
      </div>

      <Button
        type="button"
        variant="tertiary"
        size="icon"
        onClick={onRemove}
        className="rounded-md h-8 w-8 p-0 hover:bg-destructive/10 hover:text-destructive"
        aria-label={`Remove ${name}`}
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
}

SelectedOwnerRow.displayName = 'SelectedOwnerRow';

export default SelectedOwnerRow;
